import { render } from "./parkingDetail.vue?vue&type=template&id=2f16d94d&scoped=true"
import script from "./parkingDetail.vue?vue&type=script&lang=js"
export * from "./parkingDetail.vue?vue&type=script&lang=js"

import "./parkingDetail.vue?vue&type=style&index=0&id=2f16d94d&lang=scss&scoped=true"

import exportComponent from "D:\\A-wy-work\\wy-vue-source\\wy-saas\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f16d94d"]])

export default __exports__